/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ObservationstypesidObservationType from './ObservationstypesidObservationType';

/**
 * The TypesIdBody model module.
 * @module model/TypesIdBody
 * @version v0.3
 */
export default class TypesIdBody {
  /**
   * Constructs a new <code>TypesIdBody</code>.
   * @alias module:model/TypesIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TypesIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TypesIdBody} obj Optional instance to populate.
   * @return {module:model/TypesIdBody} The populated <code>TypesIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TypesIdBody();
      if (data.hasOwnProperty('observation_type'))
        obj.observationType = ObservationstypesidObservationType.constructFromObject(data['observation_type']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ObservationstypesidObservationType} observationType
 */
TypesIdBody.prototype.observationType = undefined;

